export default "__VITE_ASSET__AB4hnNZd__"